import React from 'react';

export const TicketModal = ({ ticket, onClose }) => (
  <div className="fixed inset-0 z-[120] flex items-center justify-center p-4" style={{ background: 'rgba(10,10,10,0.9)' }} data-testid="ticket-modal" onClick={onClose}>
    <div onClick={(e) => e.stopPropagation()} style={{ background: '#ffffff', color: '#111', width: '100%', maxWidth: '360px', padding: '22px', fontFamily: 'monospace' }} id="ticket-print">
      <div style={{ textAlign: 'center', borderBottom: '1px dashed #999', paddingBottom: '10px' }}>
        <div style={{ fontWeight: 700, fontSize: '18px' }}>YAMAUCHI RAMEN</div>
        <div style={{ fontSize: '12px' }}>Ticket de pedido</div>
      </div>
      <div style={{ fontSize: '12px', marginTop: '10px', lineHeight: 1.7 }}>
        <div><strong>Código:</strong> {ticket.id.slice(0, 8).toUpperCase()}</div>
        <div><strong>Orden #:</strong> {ticket.seq} · {ticket.week}</div>
        <div><strong>Cliente:</strong> {ticket.customer_name} ({ticket.customer_phone})</div>
        <div><strong>Entrega:</strong> {ticket.address}</div>
        {ticket.notes ? <div><strong>Nota:</strong> {ticket.notes}</div> : null}
      </div>
      <div style={{ borderTop: '1px dashed #999', borderBottom: '1px dashed #999', margin: '10px 0', padding: '8px 0', fontSize: '12px', lineHeight: 1.8 }}>
        {ticket.items.map((it, i) => (
          <div key={`${it.id}-${i}`} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{it.qty}× {it.name}{it.modifiers && it.modifiers.length ? ` (${it.modifiers.join(', ')})` : ''}</span>
            <span>${it.line_total.toFixed(2)}</span>
          </div>
        ))}
      </div>
      <div style={{ fontSize: '13px', display: 'flex', justifyContent: 'space-between', fontWeight: 700 }}>
        <span>TOTAL</span><span>${ticket.total.toFixed(2)}</span>
      </div>
      {ticket.tax_total ? (
        <div style={{ fontSize: '11px', display: 'flex', justifyContent: 'space-between' }}>
          <span>Tax incl.</span><span>${ticket.tax_total.toFixed(2)}</span>
        </div>
      ) : null}
      <div className="no-print" style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
        <button onClick={() => window.print()} style={{ flex: 1, background: '#C8282B', color: '#fff', border: 'none', padding: '10px', cursor: 'pointer' }} data-testid="ticket-print-btn">
          Imprimir
        </button>
        <button onClick={onClose} style={{ flex: 1, background: '#eee', color: '#111', border: 'none', padding: '10px', cursor: 'pointer' }}>
          Cerrar
        </button>
      </div>
    </div>
  </div>
);
